// @ts-check
import React, { useState } from 'react';
import { LogOut, Smartphone } from 'lucide-react';
import { useTheme } from '../../../app/providers/ThemeContext';
import { useInstallPrompt } from '../../../shared/hooks/useInstallPrompt';
import AccountSwitcher from '../../families/components/AccountSwitcher';
import AddToHomeScreenModal from './AddToHomeScreenModal';
import LoginInfoSection from './LoginInfoSection';
import SupportSection from './SupportSection';
import WecomSection from './WecomSection';
import BirthYmSection from '../../childAge/BirthYmSection';
import './StudentSettings.css';

/**
 * Settings tab content - user preferences and sign out.
 *
 * @param {Object} props
 * @param {() => void} props.onSignOut
 * @param {Array<{ authing_user_id: string, display_name: string | null, role: string }>} [props.familyMembers]
 * @param {string} [props.currentStudentId]
 * @param {(id: string) => void} [props.onSwitchAccount]
 * @param {string} [props.studentId] - the child whose 出生年月 this sheet edits
 * @param {string|null} [props.birthYm]
 * @param {(birthYm: string|null) => void} [props.onBirthYmSaved]
 */
function SettingsContent({ onSignOut, familyMembers, currentStudentId, onSwitchAccount, studentId, birthYm, onBirthYmSaved }) {
  const { preference, setThemePreference } = useTheme();
  const { canInstall, isInstalled, platform, triggerInstall } = useInstallPrompt();
  const [showA2HSModal, setShowA2HSModal] = useState(false);

  const handleAddToHomeScreen = () => {
    if (canInstall) {
      triggerInstall();
    } else {
      setShowA2HSModal(true);
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-content-inner">
        <section className="settings-section">
          <div className="settings-theme-row">
            <span className="settings-theme-label">外观</span>
            <div className="settings-theme-toggle">
              {[
                { value: 'light', label: '☀️ 浅色' },
                { value: 'dark', label: '🌙 深色' },
                { value: 'system', label: '⚙️ 系统' },
              ].map(({ value, label }) => (
                <button
                  key={value}
                  type="button"
                  className={`settings-theme-btn${preference === value ? ' settings-theme-btn--active' : ''}`}
                  onClick={() => setThemePreference(value)}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </section>

        {!isInstalled && (
          <section className="settings-section settings-install-section">
            <div className="settings-install-row">
              <div className="settings-install-info">
                <Smartphone size={18} className="settings-install-icon" />
                <span className="settings-install-label">添加到主屏幕</span>
              </div>
              <button
                type="button"
                className="settings-install-btn"
                onClick={handleAddToHomeScreen}
              >
                添加
              </button>
            </div>
          </section>
        )}

        {/* 英语水平测评 (placement re-test) row hidden for now — Rob 2026-09-15.
            Bring back: <Link to={`/placement/retest/${currentStudentId}`}> row with the TrendingUp icon. */}

        {studentId && onBirthYmSaved && (
          <BirthYmSection studentId={studentId} birthYm={birthYm ?? null} onSaved={onBirthYmSaved} />
        )}
        <LoginInfoSection />
        <SupportSection />
        <WecomSection />

        {familyMembers && familyMembers.length > 0 && (
          <AccountSwitcher
            familyMembers={familyMembers}
            currentStudentId={currentStudentId}
            onSwitchAccount={onSwitchAccount}
          />
        )}

        <section className="settings-section logout-section">
          <button className="logout-btn" onClick={onSignOut}>
            <LogOut size={18} />
            <span>退出登录</span>
          </button>
        </section>
      </div>

      <AddToHomeScreenModal
        isOpen={showA2HSModal}
        onClose={() => setShowA2HSModal(false)}
        platform={platform}
      />
    </div>
  );
}

export default SettingsContent;
